import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as NavActions from '../../store/shipments/nav/shipments.nav.actions';
import { requestGetShipments } from '../../store/shipments/shipments.actions';
import Global from '../../store/global-selectors';
import { SHIPPED_VIEW_ID } from '../../components/shipping-grid/views/view-id-constants';

import ShippingPage from './shipping-page';
import { useQuickSearchTerm } from '../../hooks/routing/use-quick-search-term';
import { clearSelectedShipments } from '../../store/shipments/selected-shipments/shipments.selected-shipments.actions';
import { useOperationsCardShipmentFilters } from './hooks/use-operations-card-shipment-filters';
import * as FilteringActions from '../../store/shipments/filtering/shipments.filtering.actions';
import { FilterViewProps } from '../../store/shipments/filtering/filterview.properties';

export const ShipmentsPageLoader = () => {
  const dispatch = useDispatch();
  const { statusViewId } = useParams();
  const isLoading = useSelector(Global.selectShipmentsGridIsLoading);

  const quickSearchTerm = useQuickSearchTerm();
  const operationsCardFilters = useOperationsCardShipmentFilters();

  useEffect(() => {
    dispatch(clearSelectedShipments());
  }, [dispatch, quickSearchTerm]);

  useEffect(() => {
    if (!statusViewId) {
      dispatch(NavActions.shipmentsChangeView(SHIPPED_VIEW_ID, false));
    }

    // Apply filters from operations card if present
    if (operationsCardFilters && operationsCardFilters.length > 0) {
      dispatch(FilteringActions.changeCustomFilterViewProp(FilterViewProps.FILTERVIEW_FILTERS, operationsCardFilters));
      dispatch(FilteringActions.autoSwitchFilterViewToCustom(operationsCardFilters, { filterViewId: SHIPPED_VIEW_ID }));
    }

    dispatch(requestGetShipments());
  }, [dispatch, statusViewId, operationsCardFilters]);

  return <ShippingPage isLoading={isLoading} />;
};
